import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Paper, Typography, CircularProgress } from "@mui/material";

export default function CollectionChoix() {
  const navigate = useNavigate();
  const idOrganisation = localStorage.getItem("idOrganisation");

  const [collections, setCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getCollections = async () => {
      if (!idOrganisation) return;

      try {
        const response = await fetch(
          "https://backend-betkiff.vercel.app/collections/getCollections",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ idOrganisation }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const dataCollection = await response.json();
        console.log("Collections récupérées :", dataCollection);

        setCollections(Object.values(dataCollection));
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des collections :",
          error
        );
      } finally {
        setIsLoading(false);
      }
    };

    getCollections();
  }, [idOrganisation]);

  const handleClick = (collection) => {
    localStorage.setItem("selectedCollection", JSON.stringify(collection));
    navigate(`/collection`);
  };

  return (
    <div style={{ padding: "20px", marginTop: "15%", paddingBottom: "20%" }}>
      <Typography variant="h1" sx={{ fontSize: "2.5rem", fontWeight: "bold" }}>
        Tes collections
      </Typography>
      <Typography
        variant="caption"
        sx={{ fontSize: "1rem", color: "rgba(90, 20, 121, 254)" }}
      >
        Choisis en une pour voir tes cartes !
      </Typography>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : collections.length > 0 ? (
        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
          {collections.map((collection) => (
            <Grid
              item
              xs={6}
              key={collection.idCollection}
              sx={{ minHeight: "220px" }}
            >
              <Paper
                elevation={3}
                sx={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  position: "relative",
                  backgroundColor: collection?.collectionImageUrl
                    ? "black"
                    : "transparent",
                  borderRadius: "15px",
                  overflow: "hidden",
                }}
                onClick={() => handleClick(collection)}
              >
                {collection.collectionImageUrl && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundImage: `url(${collection.collectionImageUrl})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      opacity: 0.5,
                    }}
                  />
                )}
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    mt: 1,
                    color: "#e1bfe4",
                    textShadow: "1px 1px 4px rgba(0, 0, 0, 0.7)",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {collection.nameCollection}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#e1bfe4",
            textShadow: "1px 1px 4px rgba(0, 0, 0, 0.7)",
          }}
        >
          Aucune collection trouvée.
        </Typography>
      )}
    </div>
  );
}
